import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function NavimummbaiAirportToPuneCab() {



    const cardData = {





keyword: "Navi Mumbai Airport to Pune Cab",

headingDescription: "Shreesha Tours & Travels offers reliable and comfortable Navi Mumbai Airport to Pune Cab Service for airport transfers, corporate travel, business meetings, family vacations, hotel transfers, one-way taxi booking, round trips, and outstation journeys. We provide chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for a smooth and hassle-free journey from Navi Mumbai Airport to Pune. With professional drivers, flight tracking, timely airport pickups, clean and well-maintained vehicles, transparent pricing, doorstep drop service, flexible booking options, and 24/7 customer support, we ensure a safe and comfortable travel experience. Whether you are traveling to Pune for business, education, tourism, medical visits, or family functions, Shreesha Tours & Travels provides dependable airport cab services with complete convenience and customer satisfaction.",

topPlaces: [
  {
    title: "Shaniwar Wada Pune",
    description: "Shaniwar Wada is Pune's most famous historical fort and a symbol of Maratha heritage, attracting tourists with its architecture, gardens, and evening light shows."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a historic landmark associated with India's freedom movement, known for its beautiful architecture, gardens, and museum."
  },
  {
    title: "Sinhagad Fort",
    description: "Sinhagad Fort is a popular trekking and sightseeing destination near Pune, offering panoramic valley views, historical significance, and local food."
  },
  {
    title: "Dagdusheth Halwai Ganpati",
    description: "Shreemant Dagdusheth Halwai Ganpati Temple is one of Pune's most visited religious attractions, attracting thousands of devotees every day."
  },
  {
    title: "Rajiv Gandhi IT Park Hinjawadi",
    description: "Hinjawadi IT Park is Pune's largest technology hub, home to leading multinational companies and a major destination for corporate travelers."
  },
  {
    title: "Koregaon Park",
    description: "Koregaon Park is known for its premium restaurants, cafés, luxury hotels, shopping destinations, and vibrant nightlife."
  },
  {
    title: "Kharadi EON IT Park",
    description: "EON IT Park in Kharadi is one of Pune's major business hubs, housing several IT companies, corporate offices, and commercial establishments."
  },
  {
    title: "Lavasa",
    description: "Lavasa is a picturesque planned hill city near Pune, famous for its lakeside promenade, adventure activities, and scenic mountain views."
  },
  {
    title: "Lonavala",
    description: "Lonavala is a beautiful hill station located between Mumbai and Pune, famous for Tiger Point, Bhushi Dam, waterfalls, and lush green valleys."
  },
  {
    title: "Mulshi Dam",
    description: "Mulshi Dam is a popular weekend destination near Pune, known for its peaceful lake, scenic mountain roads, resorts, and monsoon beauty."
  }
],


"services": [
  {
    "name": "Mumbai Airport to Pune Cab",
    "description": "Book Mumbai Airport to Pune Cab for safe, comfortable, and reliable airport transfers with professional chauffeurs and well-maintained AC vehicles. We provide direct pickup from Mumbai Airport to any location in Pune with Sedan, Hyundai Aura, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, Tempo Traveller, and luxury cab options. Enjoy 24x7 service, flight tracking, luggage assistance, transparent pricing, and doorstep drop."
  },
  {
    "name": "Mumbai to Pune Cab Service",
    "description": "Choose Mumbai to Pune Cab Service for affordable and convenient intercity travel with experienced drivers and clean vehicles. Enjoy one-way, round-trip, airport pickup, family travel, business transfers, and corporate transportation with flexible booking options."
  },
  {
    "name": "Mumbai Airport to Pune Taxi Fare",
    "description": "Get affordable Mumbai Airport to Pune Taxi Fare with transparent pricing and no hidden charges. Our competitive rates include professional drivers, comfortable AC vehicles, timely pickup, and reliable airport transfer services."
  },
  {
    "name": "Mumbai Pune Cab One Way",
    "description": "Book Mumbai Pune Cab One Way for economical drop taxi services without paying return charges. Enjoy comfortable travel, doorstep pickup, professional chauffeurs, and flexible scheduling from Mumbai Airport or Mumbai city to Pune."
  },
  {
    "name": "Mumbai to Pune Cab from Airport",
    "description": "Reserve Mumbai to Pune Cab from Airport for direct airport pickup and smooth travel to Pune. Our chauffeurs monitor flight schedules to ensure timely pickups and hassle-free transportation."
  },
  {
    "name": "Mumbai Airport to Pune Cab Fare",
    "description": "Choose Mumbai Airport to Pune Cab Fare with budget-friendly pricing, premium vehicles, and experienced drivers. Enjoy affordable airport transfers with comfortable AC cabs and transparent fare policies."
  },
  {
    "name": "Mumbai International Airport to Pune Cab",
    "description": "Book Mumbai International Airport to Pune Cab for seamless airport transfers from Terminal 1 and Terminal 2. Our professional chauffeurs provide comfortable rides, luggage assistance, and safe transportation to all Pune locations."
  },
  {
    "name": "Mumbai to Pune Taxi from Airport",
    "description": "Hire Mumbai to Pune Taxi from Airport for convenient airport transportation with clean vehicles, skilled drivers, and reliable service. Perfect for business travelers, families, students, and tourists."
  },
  {
    "name": "Navi Mumbai Airport to Pune Cab",
    "description": "Book Navi Mumbai Airport to Pune Cab for direct airport pickup with reliable chauffeurs and comfortable AC vehicles. We offer punctual airport transfers to Pune with Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and luxury cab options."
  },
  {
    "name": "Navi Mumbai Airport to Pune Taxi",
    "description": "Choose Navi Mumbai Airport to Pune Taxi for affordable airport transportation with experienced drivers, timely pickups, and comfortable travel to Pune city and nearby destinations."
  },
  {
    "name": "Navi Mumbai Airport to Pune Cab Service",
    "description": "Reserve Navi Mumbai Airport to Pune Cab Service for dependable airport pickup and drop with professional chauffeurs, flight tracking, flexible scheduling, and premium vehicles for every travel requirement."
  },
  {
    "name": "Navi Mumbai Airport to Pune Taxi Service",
    "description": "Book Navi Mumbai Airport to Pune Taxi Service for safe, reliable, and affordable intercity airport transfers with AC vehicles and courteous chauffeurs available 24x7."
  },
  {
    "name": "Cab from Navi Mumbai Airport to Pune",
    "description": "Choose Cab from Navi Mumbai Airport to Pune for smooth airport transportation with door-to-door pickup, luggage assistance, comfortable seating, and experienced drivers."
  },
  {
    "name": "Book Cab from Navi Mumbai Airport to Pune",
    "description": "Book Cab from Navi Mumbai Airport to Pune online with instant confirmation and multiple vehicle options. Select the perfect cab according to your group size and travel requirements."
  },
  {
    "name": "Online Cab Booking Navi Mumbai Airport to Pune",
    "description": "Complete Online Cab Booking Navi Mumbai Airport to Pune with secure reservations, transparent pricing, and 24x7 customer support. Enjoy fast confirmation and reliable airport transfers."
  },
  {
    "name": "Best Cab Navi Mumbai Airport to Pune",
    "description": "Choose the Best Cab Navi Mumbai Airport to Pune for premium airport transportation with experienced chauffeurs, clean vehicles, punctual pickups, and excellent customer service."
  },
  {
    "name": "Cheapest Cab Navi Mumbai Airport to Pune",
    "description": "Book the Cheapest Cab Navi Mumbai Airport to Pune with affordable pricing, professional drivers, clean AC vehicles, and dependable airport transfer services without compromising quality."
  },
  {
    "name": "Reliable Taxi Navi Mumbai Airport to Pune",
    "description": "Hire Reliable Taxi Navi Mumbai Airport to Pune for dependable airport transfers with verified chauffeurs, well-maintained vehicles, flight monitoring, and comfortable travel."
  },
  {
    "name": "Airport Pickup Cab Navi Mumbai to Pune",
    "description": "Reserve Airport Pickup Cab Navi Mumbai to Pune for timely airport arrivals with professional chauffeurs, luggage assistance, and direct transportation to your destination in Pune."
  },
  {
    "name": "One Way Cab Navi Mumbai Airport to Pune",
    "description": "Book One Way Cab Navi Mumbai Airport to Pune for economical drop taxi services without return fare charges. Enjoy convenient pickups, comfortable travel, and professional drivers."
  },
  {
    "name": "Round Trip Cab Navi Mumbai Airport to Pune",
    "description": "Choose Round Trip Cab Navi Mumbai Airport to Pune for return travel with flexible schedules, premium vehicles, and experienced chauffeurs for business visits, family trips, and airport transfers."
  },
  {
    "name": "Corporate Cab Navi Mumbai Airport to Pune",
    "description": "Book Corporate Cab Navi Mumbai Airport to Pune for executive airport transportation with premium vehicles, punctual service, trained chauffeurs, and customized business travel solutions."
  },
  {
    "name": "Luxury Cab Navi Mumbai Airport to Pune",
    "description": "Choose Luxury Cab Navi Mumbai Airport to Pune for executive-class airport transfers with premium vehicles, spacious interiors, and professional chauffeurs for VIP and corporate travel."
  },
  {
    "name": "Airport Transfer Navi Mumbai to Pune",
    "description": "Reserve Airport Transfer Navi Mumbai to Pune for seamless airport pickup and drop services with comfortable vehicles, flight tracking, transparent pricing, and experienced drivers."
  },
  {
    "name": "Innova Crysta Cab Navi Mumbai Airport to Pune",
    "description": "Book Innova Crysta Cab Navi Mumbai Airport to Pune for luxurious airport transfers with spacious seating, premium interiors, extra luggage space, and comfortable long-distance travel."
  },
  {
    "name": "Innova Cab Navi Mumbai Airport to Pune",
    "description": "Choose Innova Cab Navi Mumbai Airport to Pune for spacious airport transportation with comfortable seating and professional chauffeurs, perfect for families and business groups."
  },
  {
    "name": "Ertiga Cab Navi Mumbai Airport to Pune",
    "description": "Reserve Ertiga Cab Navi Mumbai Airport to Pune for affordable family airport transfers with comfortable seating, AC vehicles, and experienced drivers."
  },
  {
    "name": "Swift Dzire Cab Navi Mumbai Airport to Pune",
    "description": "Book Swift Dzire Cab Navi Mumbai Airport to Pune for economical airport transportation with clean AC sedans, professional chauffeurs, and timely pickup services."
  },
  {
    "name": "Kia Carens Cab Navi Mumbai Airport to Pune",
    "description": "Choose Kia Carens Cab Navi Mumbai Airport to Pune for premium family airport travel with spacious seating, modern interiors, and comfortable long-distance transportation."
  },
  {
    "name": "Sedan Cab Navi Mumbai Airport to Pune",
    "description": "Book Sedan Cab Navi Mumbai Airport to Pune for affordable and comfortable airport transfers with professional drivers and clean AC vehicles."
  },
  {
    "name": "SUV Cab Navi Mumbai Airport to Pune",
    "description": "Reserve SUV Cab Navi Mumbai Airport to Pune for spacious airport transportation with additional luggage capacity, premium comfort, and experienced chauffeurs."
  },
  {
    "name": "Hyundai Aura Cab Navi Mumbai Airport to Pune",
    "description": "Choose Hyundai Aura Cab Navi Mumbai Airport to Pune for economical airport transfers with clean AC cars, professional drivers, and comfortable travel from the airport to Pune."
  }
],
"tableData": [
  ["Mumbai Airport to Pune Cab", "Mumbai to Pune Cab Service"],
  ["Mumbai Airport to Pune Taxi Fare", "Mumbai Pune Cab One Way"],
  ["Mumbai to Pune Cab from Airport", "Mumbai Airport to Pune Cab Fare"],
  ["Mumbai International Airport to Pune Cab", "Mumbai to Pune Taxi from Airport"],
  ["Navi Mumbai Airport to Pune Cab", "Navi Mumbai Airport to Pune Taxi"],
  ["Navi Mumbai Airport to Pune Cab Service", "Navi Mumbai Airport to Pune Taxi Service"],
  ["Cab from Navi Mumbai Airport to Pune", "Book Cab from Navi Mumbai Airport to Pune"],
  ["Online Cab Booking Navi Mumbai Airport to Pune", "Best Cab Navi Mumbai Airport to Pune"],
  ["Cheapest Cab Navi Mumbai Airport to Pune", "Reliable Taxi Navi Mumbai Airport to Pune"],
  ["Airport Pickup Cab Navi Mumbai to Pune", "One Way Cab Navi Mumbai Airport to Pune"],
  ["Round Trip Cab Navi Mumbai Airport to Pune", "Corporate Cab Navi Mumbai Airport to Pune"],
  ["Luxury Cab Navi Mumbai Airport to Pune", "Airport Transfer Navi Mumbai to Pune"],
  ["Innova Crysta Cab Navi Mumbai Airport to Pune", "Innova Cab Navi Mumbai Airport to Pune"],
  ["Ertiga Cab Navi Mumbai Airport to Pune", "Swift Dzire Cab Navi Mumbai Airport to Pune"],
  ["Kia Carens Cab Navi Mumbai Airport to Pune", "Sedan Cab Navi Mumbai Airport to Pune"],
  ["SUV Cab Navi Mumbai Airport to Pune", "Hyundai Aura Cab Navi Mumbai Airport to Pune"]
],




whychoose: [
  {
    WhyChooseheading: "Convenient Navi Mumbai Airport to Pune Cab Service",
    WhyChoosedescription: "Land at Navi Mumbai Airport and continue your journey to Pune without changing multiple modes of transport. Shreesha Travels provides comfortable chauffeur-driven cabs for individuals, families, corporate travellers, and tourists with dependable door-to-door service."
  },
  {
    WhyChooseheading: "Direct Airport Transfers to Every Pune Location",
    WhyChoosedescription: "Our private cabs offer direct transportation from Navi Mumbai Airport to Hinjewadi, Baner, Kharadi, Wakad, Viman Nagar, Kothrud, Magarpatta, Hadapsar, Pimpri-Chinchwad, and all major areas across Pune."
  },
  {
    WhyChooseheading: "Vehicle Choices for Every Travel Need",
    WhyChoosedescription: "Book Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles based on passenger count, luggage requirements, and travel comfort."
  },
  {
    WhyChooseheading: "Ideal for Corporate, Family & Student Travel",
    WhyChoosedescription: "Our Navi Mumbai Airport to Pune cab service is suitable for business meetings, IT professionals, family visits, hotel transfers, university travel, medical appointments, and weekend getaways."
  },
  {
    WhyChooseheading: "One-Way & Return Transfer Options",
    WhyChoosedescription: "Reserve a one-way airport cab to Pune or choose a round-trip package for return airport transfers with flexible schedules and customized travel plans."
  },
  {
    WhyChooseheading: "Professional Drivers with Expressway Experience",
    WhyChoosedescription: "Our experienced chauffeurs are familiar with the Mumbai–Pune Expressway and alternate routes, ensuring safe driving, punctual service, and a comfortable long-distance journey."
  },
  {
    WhyChooseheading: "Clean, Air-Conditioned & Ready-to-Travel Vehicles",
    WhyChoosedescription: "Every cab is thoroughly cleaned, sanitized, air-conditioned, and regularly maintained to provide a relaxing airport transfer experience from pickup to destination."
  },
  {
    WhyChooseheading: "Book Navi Mumbai Airport to Pune Cab with Shreesha Travels",
    WhyChoosedescription: "Receive transparent pricing, instant booking confirmation, reliable chauffeur service, and comfortable airport transportation from Navi Mumbai Airport to any destination in Pune."
  }
]

};

const faqData = [
  {
    question: "Can I pre-book a cab from Navi Mumbai Airport to Pune?",
    answer: "Yes, you can reserve your airport cab in advance by sharing your flight details and preferred pickup time."
  },
  {
    question: "Do you provide direct airport transfers to Pune?",
    answer: "Yes, we offer direct chauffeur-driven cab service from Navi Mumbai Airport to all residential, commercial, and industrial areas in Pune."
  },
  {
    question: "Which cars are available for Navi Mumbai Airport to Pune travel?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Can I book a one-way cab from Navi Mumbai Airport to Pune?",
    answer: "Yes, one-way airport cab bookings are available along with round-trip transfer options."
  },
  {
    question: "Is this service suitable for IT professionals and corporate travellers?",
    answer: "Yes, our airport cab service is widely used for corporate travel, office transfers, client visits, and business meetings in Pune."
  },
  {
    question: "Do drivers wait if my flight is delayed?",
    answer: "Yes, our team coordinates using your flight information to manage pickup timing whenever possible."
  },
  {
    question: "Can I request pickup during late-night or early-morning hours?",
    answer: "Yes, airport cab services are available 24x7 for scheduled arrivals and departures."
  },
  {
    question: "How is the Navi Mumbai Airport to Pune cab fare determined?",
    answer: "The fare depends on the selected vehicle, travel distance, trip timing, toll charges, parking charges, and additional travel preferences."
  },
  {
    question: "Can I choose my drop location anywhere in Pune?",
    answer: "Yes, we provide doorstep drop service to homes, offices, hotels, educational institutions, hospitals, and other locations across Pune."
  },
  {
    question: "How can I book Navi Mumbai Airport to Pune Cab with Shreesha Travels?",
    answer: "Provide your flight details, arrival terminal, destination in Pune, travel date, passenger count, and preferred vehicle to receive a customized quotation and confirmed booking."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ketan Kulkarni",
    feedback: "Our airport transfer to Pune was smooth from start to finish. The driver arrived on time, the vehicle was comfortable, and the journey was completely hassle-free.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Aishwarya Deshpande",
    feedback: "Fantastic service after a late-night flight. The chauffeur was professional, the car was spotless, and we reached Pune safely and comfortably.",
    rating: 5
  }
];




    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai Airport to Pune Cab",
  "image": "https://www.shreeshatravels.com/assets/images/navi-mumbai-airport-to-pune-cab.webp",
  "description":
    "Book Navi Mumbai Airport to Pune Cab with Shreesha Tours & Travels for safe and reliable airport taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for one-way, round-trip, family travel, business travel, and comfortable outstation journeys from Navi Mumbai Airport to Pune with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/navi-mumbai-airport-to-pune-cab"
  }
};





    return (
        <div>
<Helmet>
  <title>Navi Mumbai Airport to Pune Cab | Airport Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Navi Mumbai Airport to Pune Cab with Shreesha Travels for safe and comfortable airport taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for one-way, round-trip, family trips, business travel, and 24x7 airport transfers from Navi Mumbai Airport to Pune."
  />

  <meta
    name="keywords"
    content="Mumbai Airport to Pune Cab, Mumbai to Pune Cab Service, Mumbai Airport to Pune Taxi Fare, Mumbai Pune Cab One Way, Mumbai to Pune Cab from Airport, Navi Mumbai Airport to Pune Cab, Navi Mumbai Airport to Pune Taxi, Pune Airport Transfer, One Way Cab Mumbai Airport to Pune, Airport Taxi Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/85.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default NavimummbaiAirportToPuneCab;